<section class="sidebar" #sidebarSection [ngClass]="{ opened: !sidebarService.isHidden() }">
  <app-sidebar
    [brandingData]="logoService.branding$ | async"
    [collapsed]="sidebarService.isCollapsed()"
  ></app-sidebar>
  <div class="toggle-icon clickable" (click)="sidebarService.toggle()">
    <app-icon-chevron
      [direction]="sidebarService.isCollapsed() ? 'right' : 'left'"
      [width]="20"
      [height]="20"
      [color]="'var(--color-gray-500)'"
    ></app-icon-chevron>
  </div>
</section>

@let isPanelOpened = (sidebarPanelService.isPanelOpened$ | async) === true;

<!-- Panels such as filters get the shared backdrop; only the sidebar keeps its own look -->
<div
  class="backdrop backdrop-below-dialogs"
  [ngClass]="{
    hidden: sidebarService.isHidden() && !isPanelOpened,
    'backdrop-sidebar': !isPanelOpened,
  }"
  (click)="hideOpenedPanel()"
></div>

<section class="content" #contentSection>
  <router-outlet></router-outlet>
</section>

@defer {
  @if (assistant.state.isDialogMode()) {
    <app-assistant-dialog [sidebarOffset]="sidebarOffset()"></app-assistant-dialog>
  }
}

@defer {
  @if (intercom.state.status()) {
    <app-intercom
      [sidebarOffset]="sidebarOffset()"
      [behindOverlays]="isSidebarOverlayOpen()"
      [fullWidth]="isPhoneLayout()"
    ></app-intercom>
  }
}
